/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export { ConfiguratorMessageConfig } from './configurator-message.config';
export { ConfiguratorUISettingsConfig } from './configurator-ui-settings.config';
import './augmented-config.model';
